import { render, staticRenderFns } from "./CalendarPager.vue?vue&type=template&id=64b8d006&"
import script from "./CalendarPager.vue?vue&type=script&lang=js&"
export * from "./CalendarPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports